import {useSelector} from "react-redux";
import {selectEntity} from "state/selectors/data";

export function useNode(id) {
    return useSelector((s)=>selectEntity(s, 'db.nodes', id))
}